module.exports = __webpack_public_path__ + "static/media/pic11.1d55f4d0.jpg";